import { render, staticRenderFns } from "./UploadContractForm.vue?vue&type=template&id=715e197e&scoped=true"
import script from "./UploadContractForm.vue?vue&type=script&lang=js"
export * from "./UploadContractForm.vue?vue&type=script&lang=js"
import style0 from "./UploadContractForm.vue?vue&type=style&index=0&id=715e197e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e197e",
  null
  
)

export default component.exports